import { withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Navigation from "./Navigation";

import logo from "../gonext1.png";

import { Card, Grid } from "@material-ui/core";
import styles from "../styles";

class aboutPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AppBar position="absolute" color="default" className={classes.appBar}>
          <Toolbar className={classes.toolbar} style={{ marginBottom: "1em" }}>
            <Typography variant="h6" color="inherit" noWrap>
              <div>
                <button
                  className={classes.homeButton}
                  onClick={this.refreshPage}
                  color="#F9F9F9"
                >
                  <img className={classes.logo} src={logo} alt="logo"></img>

                  <h4
                    style={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      display: "inline-block",
                      paddingLeft: "10px",
                    }}
                  >
                    {" "}
                    Cloud Translate
                  </h4>
                </button>
              </div>

              <Typography
                variant="h6"
                style={{ fontStyle: "italic", paddingLeft: ".25em", textWrap: 'pretty' }}
              >
                Translate Between AWS and GCP CLI Commands
              </Typography>
              <Navigation></Navigation>
            </Typography>
          </Toolbar>
        </AppBar>

        <div className={classes.aboutPageRoot} style={{ margin: "1em" }}>
          <Card elevation={5} style={{ borderRadius: ".5em" }}>
            <Grid
              item
              container
              direction="column"
              style={{ marginTop: "1em" }}
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <h2>What is this app? </h2>
              </Grid>
              <Grid item style={{ margin: "1em" }}>
                <Typography>
                  This app finds equivalent CLI commands between different cloud
                  providers (currently, only between AWS and GCP). For example,
                  typing in the GCP command{" "}
                  <em style={{ fontWeight: "bold" }}>gcloud config list</em>{" "}
                  will return
                  <i style={{ fontWeight: "bold" }}> aws configure list</i>, its
                  equivalent in AWS.
                </Typography>
              </Grid>
            </Grid>
          </Card>

          <Card
            elevation={5}
            style={{ borderRadius: ".5em", marginTop: "2em" }}
          >
            <Grid
              item
              container
              direction="column"
              style={{ marginTop: "1em" }}
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <h2>How does this work?</h2>
              </Grid>
              <Grid item style={{ margin: "1em" }}>
                <Typography>
                  This app uses a database of AWS and GCP CLI commands, which
                  were manually matched together. Most commands share an
                  equivalent command in another cloud provider's CLI. Sometimes,
                  they do not - in these cases, the output command will show up
                  as <i>"(No Matching Command)"</i>. Other times, commands are
                  similar, where the function does something relatively similar;
                  for these, a <i>**</i> (double asteriks) will show up next to
                  the output command.
                </Typography>
              </Grid>
            </Grid>
          </Card>

          <Card
            elevation={5}
            style={{ borderRadius: ".5em", marginTop: "2em" }}
          >
            <Grid
              item
              container
              direction="column"
              style={{ marginTop: "1em" }}
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <h2>Where should I submit feedback?</h2>
              </Grid>
              <Grid item style={{ margin: "1em" }}>
                <Typography>
                  If you have any feedback, please send me an email at{" "}
                  <i>stefangouyet+cloudtranslate@gmail.com</i>{" "}
                </Typography>
              </Grid>
            </Grid>
          </Card>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(aboutPage);
